import type { Action } from 'redux'
import { combineReducers } from 'redux'
import { TOGGLE_REPORT_BUG_DIALOG } from 'ReportBugDialog/constants'

import { SIDE_MENU_TOGGLE } from './constants'

function isMenuOpened(state = false, { type }: Action) {
  switch (type) {
    case SIDE_MENU_TOGGLE:
      return !state
    case TOGGLE_REPORT_BUG_DIALOG:
      return false
    default:
      return state
  }
}

export default combineReducers({
  isMenuOpened,
})
